
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as g0vOFHREzJwNcRIPG8oJxb7Q7fQfi5otcDPYlGTcaLOwMeta } from "/codebuild/output/src1023664730/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/g.vue?macro=true";
import { default as index8IPWKwiOM1i3qPSwrbrl0n3L6oQCe7SuZ8p02RE_BzwMeta } from "/codebuild/output/src1023664730/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/index.vue?macro=true";
import { default as searchHYV_y58TqqUAhdB58qH8z3_vK_45HmxWLdKfGgYRMEOrkMeta } from "/codebuild/output/src1023664730/src/actions-runner/_work/onenews/onenews/web-services/common/pages/search.vue?macro=true";
import { default as indexWRxJInMvGnMN8b6w1NDZQoH99FazmirBvbQ1F5ZnRqMMeta } from "/codebuild/output/src1023664730/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/index.vue?macro=true";
import { default as _91id_93_45cTKaXpgq1iilxSC62Lty3hjKEeMOl11qVhKoCN2mmoMeta } from "/codebuild/output/src1023664730/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/video/[id].vue?macro=true";
import { default as indexrdsyFa_45XjUnHvyF_45FOd5E92HeP9EOfyMp8jb0917_455QMeta } from "/codebuild/output/src1023664730/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/terms/index.vue?macro=true";
import { default as _91id_93GeuDzroQF9FJaVTpSlrmcR9_45HwWoGIAmR4AMkWuLuy4Meta } from "/codebuild/output/src1023664730/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/article/[id].vue?macro=true";
import { default as indexH75L9KXZFvl_45xmZe_GaFFcZ_is4WykeJFmX_45N64IcG8Meta } from "/codebuild/output/src1023664730/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/contact/index.vue?macro=true";
import { default as _91id_93XATULIlgAyuIpTi3RoP5N5UECuGAqxSs_45ukKDDQ0hOEMeta } from "/codebuild/output/src1023664730/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/article/[id].vue?macro=true";
import { default as indexMz1WHaiboyxSwi1ovxz40P1JusaEIfewqbwtg_kjekcMeta } from "/codebuild/output/src1023664730/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/index.vue?macro=true";
import { default as indexbFtmWLmzeQNbzRPvCw6TLBoWX2q3Owdy_459qppiupv7EMeta } from "/codebuild/output/src1023664730/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/relationships/index.vue?macro=true";
export default [
  {
    name: "g",
    path: "/g",
    component: () => import("/codebuild/output/src1023664730/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/g.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/codebuild/output/src1023664730/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/index.vue")
  },
  {
    name: "search",
    path: "/search",
    component: () => import("/codebuild/output/src1023664730/src/actions-runner/_work/onenews/onenews/web-services/common/pages/search.vue")
  },
  {
    name: "v8",
    path: "/v8",
    component: () => import("/codebuild/output/src1023664730/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/index.vue")
  },
  {
    name: "video-id",
    path: "/video/:id()",
    component: () => import("/codebuild/output/src1023664730/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/video/[id].vue")
  },
  {
    name: "terms",
    path: "/terms",
    meta: indexrdsyFa_45XjUnHvyF_45FOd5E92HeP9EOfyMp8jb0917_455QMeta || {},
    component: () => import("/codebuild/output/src1023664730/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/terms/index.vue")
  },
  {
    name: "article-id",
    path: "/article/:id()",
    component: () => import("/codebuild/output/src1023664730/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/article/[id].vue")
  },
  {
    name: "contact",
    path: "/contact",
    meta: indexH75L9KXZFvl_45xmZe_GaFFcZ_is4WykeJFmX_45N64IcG8Meta || {},
    component: () => import("/codebuild/output/src1023664730/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/contact/index.vue")
  },
  {
    name: "v8-article-id",
    path: "/v8/article/:id()",
    component: () => import("/codebuild/output/src1023664730/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/article/[id].vue")
  },
  {
    name: "privacy-policy",
    path: "/privacy-policy",
    meta: indexMz1WHaiboyxSwi1ovxz40P1JusaEIfewqbwtg_kjekcMeta || {},
    component: () => import("/codebuild/output/src1023664730/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/index.vue")
  },
  {
    name: "privacy-policy-relationships",
    path: "/privacy-policy/relationships",
    meta: indexbFtmWLmzeQNbzRPvCw6TLBoWX2q3Owdy_459qppiupv7EMeta || {},
    component: () => import("/codebuild/output/src1023664730/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/relationships/index.vue")
  }
]